export const messages = {
  en: {
    userIntegral: {
      queryCondition: 'Query Condition',
      selectAccountName: 'Please select account name',
      query: 'Query',
      userIntegral: 'User Integral',
      number: 'Number',
      accountName: 'Account Name',
      objectType: 'Object Type',
      merchant: 'Merchant',
      user: 'User',
      userNumber: 'User Number',
      phoneNumber: 'Phone Number',
      integralCount: 'Integral Count',
      operation: 'Operation',
      give: 'Give',
      deduct: 'Deduct',
      delete: 'Delete'
    },
    editIntegral: {
      giveIntegral: 'Give Integral',
      deductIntegral: 'Deduct Integral',
      integralAccount: 'Integral Account',
      remainingIntegral: 'Remaining Integral',
      giveAmount: 'Give Amount',
      deductAmount: 'Deduct Amount',
      requiredQuantity: 'Required, please enter quantity',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      cancel: 'Cancel',
      submit: 'Submit',
      operateSuccess: 'Operation successful',
      quantityRequired: 'Quantity is required'
    },
    deleteIntegral: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteIntegral: 'Confirm to delete integral account',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successful'
    }
  },
  zh: {
    userIntegral: {
      queryCondition: '查询条件',
      selectAccountName: '请选择账户名称',
      query: '查询',
      userIntegral: '用户积分',
      number: '编号',
      accountName: '账户名称',
      objectType: '对象类型',
      merchant: '商户',
      user: '用户',
      userNumber: '用户编号',
      phoneNumber: '手机号',
      integralCount: '积分数',
      operation: '操作',
      give: '赠送',
      deduct: '扣减',
      delete: '删除'
    },
    editIntegral: {
      giveIntegral: '赠送积分',
      deductIntegral: '扣减积分',
      integralAccount: '积分账户',
      remainingIntegral: '剩余积分',
      giveAmount: '赠送数量',
      deductAmount: '扣减数量',
      requiredQuantity: '必填，请填写数量',
      remark: '说明',
      remarkPlaceholder: '请填写说明',
      cancel: '取消',
      submit: '提交',
      operateSuccess: '操作成功',
      quantityRequired: '数量不能为空'
    },
    deleteIntegral: {
      confirmOperation: '请确认您的操作',
      confirmDeleteIntegral: '确定删除积分账户',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功'
    }
  }
}